/* eslint-disable no-underscore-dangle */
import React from 'react'

// Shells import
import BannerShell from 'components/flex/Banner/BannerShell'
import FormShell from 'components/flex/Form/FormShell'
import TextShell from 'components/flex/Text/TextShell'
import ImageShell from 'components/flex/Image/ImageShell'
import PostsShell from 'components/flex/Posts/PostsShell'
import ComponentsShell from 'components/flex/Components/ComponentsShell'
import Whitespace from 'components/flex/Whitespace'
import Configurator from 'components/flex/Configurator/Configurator'
import Fragment from 'components/flex/Fragment'
import GalleryShell from 'components/flex/Gallery/GalleryShell'

interface FlexContentProps {
  prefix?: string
  fields: any
  location?: any
  pageContext?: any
}

interface FlexerProps {
  [key: string]: any
}

interface ComponentProps {
  fields: any
  location?: any
  pageContext?: any
}

const FlexContentHandler: React.FC<FlexContentProps> = ({
  prefix = 'page_Flexcontent',
  fields,
  location = {},
  pageContext,
}) => {
  if (!fields) {
    return null
  }

  const flexers: FlexerProps = {
    [`${prefix}_Flex_Banner`]: BannerShell,
    [`${prefix}_Flex_Form`]: FormShell,
    [`${prefix}_Flex_Text`]: TextShell,
    [`${prefix}_Flex_Image`]: ImageShell,
    [`${prefix}_Flex_Gallery`]: GalleryShell,
    [`${prefix}_Flex_PostTypes`]: PostsShell,
    [`${prefix}_Flex_Components`]: ComponentsShell,
    [`${prefix}_Flex_Whitespace`]: Whitespace,
    [`${prefix}_Flex_Fragment`]: Fragment,
    [`${prefix}_Flex_Configurator`]: Configurator,
  }

  if (!fields.flex) {
    return null
  }

  return (
    <>
      {fields.flex.map((section: any, index: number) => {
        if (!section.fieldGroupName || !flexers[section.fieldGroupName]) {
          return null
        }

        const Component: React.FC<ComponentProps> =
          flexers[section.fieldGroupName]

        return (
          <Component
            // eslint-disable-next-line react/no-array-index-key
            key={`${location ? location.pathname : 'flex'}-${index}`}
            fields={section}
            location={location}
            pageContext={pageContext}
          />
        )
      })}
    </>
  )
}

export default FlexContentHandler
